import { State } from '../@types';

export const selectNotifications = (store: State) => store.ui.notifications;
